module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-557.f704eab.woff2";